<button mat-button type="button" class="square-button"
        [type]="type"
        [ngClass]="theme"
        [disabled]="disabled"
        [class.button-disabled]="disabled || loading"
>
	{{ value }}
	<mat-icon *ngIf="icon">{{ icon }}</mat-icon>
</button>
